//Dependencies
import React from 'react';
import {Route,Switch} from 'react-router-dom';

//Components
import App from './Components/App';
import Empleados from './Components/Empleados/Empleados';
import Vehiculos from './Components/Vehiculos/Vehiculos'; 
import TarifasVehiculos from './Components/Tarifas/TarifasVehiculos';
import Empresa from './Components/Empresa/Empresa';
import Calificaciones from './Components/Calificaciones/Calificaciones';
import ViajesEmpleados from './Components/Empleados_empresa/ViajesEmpleados';
import VehiculosBases from './Components/Vehiculos_Bases/VehiculosBases';
import EmpleadoEmpresa from './Components/Empleados_empresa/Empleados_empresa';
import Perfiles from './Components/Perfiles/Perfiles';
import Informacion from './Components/Informacion/Informacion';
import Usuarios from './Components/Usuarios/Usuarios';
import Tarifas from './Components/Tarifas/Tarifas';
import About from './Components/About';
import Contact from './Components/Contact';
import Home from './Components/Home';
import Costos from './Components/Costos/Costos';
import Asignar from './Components/Asignar/Asignar';
import NuevoViaje from './Components/Programacion/selecionRango';
import NuevoTipo from './Components/Programacion/selecionTipo';
import ViajeNuevo from './Components/Programacion/nuevoViaje';
import cargaEmple from './Components/Programacion/cargaEmple';
import cambioViajes from './Components/Programacion/cambioViajes';
import planiViajes from './Components/Planificacion/planiViajes';
import AsignarConductor from './Components/Reservas/asignarConductor';
import newRutas from './Components/Rutas/newRutes';

// For CRUD de programaciones
import programacionCrud from './Components/Programacion CRUD';

const AppRoutes = () =>
<App>
	<Switch>
		<Route path="/asignarC" component={AsignarConductor}/>
		<Route path="/newRutas" component={newRutas}/>
		<Route path="/nuevoViaje" component = {ViajeNuevo}/> 
		<Route path="/selecionTipo/:tipo" component = {NuevoTipo}/> 
		<Route path="/selecionRango" component = {NuevoViaje}/> 
		<Route path="/about" component = {Asignar}/> 
		<Route path="/adicciones" component = {cambioViajes}/> 
		<Route path="/planiViajes" component = {planiViajes}/> 	
		<Route path="/asignar" component = {About}/>	
		<Route path="/contact" component={Contact}/>
		<Route path="/empleados" component={Empleados}/>
		<Route path="/vehiculos" component={Vehiculos}/>
		<Route path="/empresa" component={Empresa}/>
		<Route path="/informacion" component={Informacion}/>
		<Route path="/perfiles" component={Perfiles}/>
		<Route path="/tarifas" component={Tarifas}/>
		<Route path="/tarifas_vehiculos" component={TarifasVehiculos}/>
		<Route path="/usuarios" component={Usuarios}/>
		<Route path="/costos" component={Costos}/>
		<Route path="/cargaemple" component={cargaEmple}/>
		<Route path="/calificaciones" component={Calificaciones}/>
		<Route path="/viajes/:uid" component={ViajesEmpleados}/>
		<Route path="/vehiculos_bases/:base/:nombre" component={VehiculosBases}/>
		<Route path="/empresa_empleados/:idempresa/:nombre" component={EmpleadoEmpresa} />

		<Route path="/crudProgramacion" component={programacionCrud}/>	
		<Route path="/" component={Home} />
	</Switch>
</App>

export default AppRoutes;



// WEBPACK FOOTER //
// ./src/routes.js